import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-quotation',
  templateUrl: './quotation.component.html',
  styleUrls: ['./quotation.component.css']
})
export class QuotationComponent implements OnInit {
  customerValues: any;
  productDetails : any;
  constructor() { }

  ngOnInit(): void {
  }

  customerDetailShow(val: any){
    this.customerValues = val;
 //   console.log('parent component', this.customerValues);
  }

  onProudctDetails(value : any){
      this.productDetails = value;
  }
 s

}
